/**
 * TanStack Query hooks for `favicon`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	faviconQueryKeys,
	type CreateFaviconBody,
	type ListFaviconResponse,
	type FaviconRow,
} from "./api";

export function useFaviconList(): UseQueryResult<ListFaviconResponse, Error> {
	return useQuery({
		queryKey: faviconQueryKeys.list(),
		queryFn: list,
	});
}

export function useFaviconCreate(): UseMutationResult<FaviconRow, Error, CreateFaviconBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: faviconQueryKeys.all });
		},
	});
}

export function useFaviconDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: faviconQueryKeys.all });
		},
	});
}
